// Availability ------------------------------------------------------------------------
export var FlowMessengerNodeAvailabilityStrategy;
(function (FlowMessengerNodeAvailabilityStrategy) {
    FlowMessengerNodeAvailabilityStrategy["NoAgentsAvailable"] = "noAgentsAvailable";
    FlowMessengerNodeAvailabilityStrategy["NeverAvailable"] = "neverAvailable";
    FlowMessengerNodeAvailabilityStrategy["AlwaysAvailable"] = "alwaysAvailable";
})(FlowMessengerNodeAvailabilityStrategy || (FlowMessengerNodeAvailabilityStrategy = {}));
